import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class XC38AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
    }

    handleLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.AftCabinLayout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard of the Xc 38 is double berth and shelves in both aft cabins.' /></p>
                    <p><Trans defaults='Optional is freeboard hung sea berths in port side aft cabin. Please, note that sea berth is not an option unless shelf is de-selected.' /></p>

                    <RadioGroup options={this.props.aftCabinOptions} value={this.props.configuration.AftCabinLayout} onChange={this.handleLayoutChange} />
                    
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38AftCabin);


// WEBPACK FOOTER //
// ./src/XC38/XC38AftCabin.js